module.exports = __webpack_public_path__ + "prod/1.42.2/img/H5banner.37d4cdb7.png";